// extracted by mini-css-extract-plugin
module.exports = {"paymentMethod":"TransactionPaymentMethod_paymentMethod__2r760","info":"TransactionPaymentMethod_info__1TBC4"};